import { createSlice } from "@reduxjs/toolkit";

const initialState = { tokenData: {}, isLoggedIn: false, loading: false };

const auth = createSlice({
   name: "auth",
   initialState,
   reducers: {
      setTokenData(state, action) {
         state.tokenData = action.payload;
      },
      setLoginStatus(state, action) {
         state.isLoggedIn = action.payload;
      },

      resetAuthData() {
         return initialState;
      },

      setLoading(state, action) {
         state.loading = action.payload;
      },
   },
});

export const authAction = auth.actions;
export const authReducer = auth.reducer;
